<!-- zusaetzliche Details -->
<div [class.hide]="!open" class="tRow tbodyrowDetails">
    <div class="tCellfixed"></div>
    <div class="tCellflexible">
        <div class="tCell" style="width: 25%;">
            <div class="textOverflow">Auftragsdetails:</div>
            <div class="textOverflow">{{ buergschein.statusanzeigeBuergschaft === 'IN_BEARBEITUNG' ? 'Antragsdatum:' : 'Ausstellungsdatum:' }}</div>
            <div class="textOverflow">Geschäftsjahr:</div>
            <div class="textOverflow">Bürgschaftsart:</div>
        </div>
        <div class="tCell" style="width:45%;">
            <div class="textOverflow">{{ model?.auftrag1 }}</div>
            <div class="textOverflow">{{ model?.ausstellungsdatum }}</div>
            <div class="textOverflow">{{ $safeNavigationMigration(model?.ausstellungsdatum) | pickYearOfDeDate }}</div>
            <div>{{ translateBuergscheinArt($safeNavigationMigration(model?.buergschaftsArt)) }}</div>
        </div>
        <div class="tCell" style="width:27%;">
            <div class="textOverflow">{{ model?.auftraggeberinfo1 }}</div>
            <div class="textOverflow">{{ model?.auftraggeberinfo2 }}</div>
            <div class="textOverflow">{{ model?.auftraggeberinfo3 }}</div>
        </div>
    </div>
    <div class="tCellfixed">
    </div>
</div>

<!-- Aktionsbuttons -->
<div [class.hide]="!open" class="tRow tbodyrowActions">
    <div class="tCellflexible"> <!-- das colspan muss die Summe aller Zellen umfassen -->
        <div class="tCell" style="width: 100%;">
            <div class="actionsContainer">
                @if (buergschein.dokumentId && !buergschein.originalDokumentId) {
                    <elem-button buttonRole="SECONDARY"
                                 icon="icon-document"
                                 (click)="downloadBuergschein(false)">Herunterladen</elem-button>
                }

                @if (buergschein.dokumentId && buergschein.originalDokumentId) {
                    <elem-button buttonRole="SECONDARY"
                                 icon="icon-document"
                                 (click)="downloadBuergschein(true)">Original herunterladen</elem-button>

                    <elem-button buttonRole="SECONDARY"
                                 icon="icon-document"
                                 (click)="downloadBuergschein(false)">Kopie herunterladen</elem-button>
                }

                <elem-button buttonRole="SECONDARY"
                             icon="icon-duplicate"
                             (click)="createBuergscheinWithVorlage()">Als Vorlage nutzen</elem-button>

                @if (canModifyBs()) {
                    <elem-button buttonRole="SECONDARY"
                                 icon="icon-edit_1"
                                 (click)="createBuergscheinWithVorlage(true)">Änderungsauftrag</elem-button>

                    @if (open) {
                        <print-enthaftungserklaerung [model]="model" style="margin-left: 1rem"></print-enthaftungserklaerung>
                    }
                }

                @if (buergschein.versandweg === 'TRUSTLOG') {
                    <elem-button buttonRole="SECONDARY"
                                 icon="icon-guarantee"
                                 style="margin-left: 1rem"
                                 [disabled]="rueckforderungLocked"
                                 (click)="rueckforderungBuergschaft()">Rückforderung</elem-button>
                }
            </div>
        </div>
    </div>
</div>
